import { useEffect, useId, useRef, useState, type KeyboardEvent, type ReactNode, type RefObject } from 'react'
import { Button } from '../design'
import { SHELL_COPY } from './copy'

const useDismissOnOutsidePress = (open: boolean, root: RefObject<HTMLElement | null>, setOpen: (open: boolean) => void) => {
  useEffect(() => {
    if (!open) return
    const onPress = (event: PointerEvent) => {
      if (event.target instanceof Node && root.current?.contains(event.target) !== true) setOpen(false)
    }
    document.addEventListener('pointerdown', onPress)
    return () => document.removeEventListener('pointerdown', onPress)
  }, [open, root, setOpen])
}

export const AppBarMenu = ({ children }: { children: ReactNode }) => {
  const [open, setOpen] = useState(false)
  const panelId = useId()
  const root = useRef<HTMLDivElement>(null)
  const toggle = useRef<HTMLButtonElement>(null)
  useDismissOnOutsidePress(open, root, setOpen)

  const onKeyDown = (event: KeyboardEvent) => {
    if (event.key !== 'Escape' || !open) return
    setOpen(false)
    toggle.current?.focus()
  }

  return (
    <div className="appbar-menu" ref={root} onKeyDown={onKeyDown}>
      <Button
        ref={toggle}
        variant="ghost"
        className="appbar-menu-toggle"
        aria-label={SHELL_COPY.moreActions}
        aria-expanded={open}
        aria-controls={panelId}
        onClick={() => setOpen(!open)}
      >
        {SHELL_COPY.more}
      </Button>
      <div id={panelId} role="group" aria-label={SHELL_COPY.moreActions} className="appbar-menu-panel" hidden={!open}>
        {children}
      </div>
    </div>
  )
}
